export const apbCommunityNewsletter = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  name: 'Agile Product Builders Community Newsletter',
  url: 'https://www.boldare.com/apb-community-newsletter/',
  description:
    'Monthly newsletter delivering expert insights and practical advice on building digital products, curated with help from the Agile Product Builders Community. Subscribers get exclusive access to the community to share experiences and influence content topics.',
  publisher: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com',
  },
  about: {
    '@type': 'Organization',
    name: 'Agile Product Builders Community',
    description:
      'A community connecting professionals involved in digital product building to share experience, challenge, and excite each other.',
  },
};
